import { useEffect, useSyncExternalStore } from 'react'
import {
  getBreadcrumbLeaf,
  getBreadcrumbTrailOverride,
  setBreadcrumbLeaf,
  setBreadcrumbTrailOverride,
  subscribeBreadcrumb,
  type Crumb
} from '@/lib/breadcrumbs'

export function useBreadcrumb(label?: string | null): void {
  useEffect(() => {
    setBreadcrumbLeaf(label ?? null)
    return () => setBreadcrumbLeaf(null)
  }, [label])
}

export function useBreadcrumbLeaf(): string | null {
  return useSyncExternalStore(subscribeBreadcrumb, getBreadcrumbLeaf, getBreadcrumbLeaf)
}

export function useBreadcrumbTrail(trail: Crumb[] | null): void {
  useEffect(() => {
    setBreadcrumbTrailOverride(trail)
    return () => setBreadcrumbTrailOverride(null)
  }, [trail])
}

export function useBreadcrumbTrailOverride(): Crumb[] | null {
  return useSyncExternalStore(subscribeBreadcrumb, getBreadcrumbTrailOverride, getBreadcrumbTrailOverride)
}
